document.addEventListener('alpine:init', () => {
    // Accordion group controller - manages exclusive mode
    Alpine.data('accordionGroup', (config = {}) => ({
        exclusive: config.exclusive || false,
        items: [],

        registerItem(item) {
            this.items.push(item);
        },

        unregisterItem(item) {
            this.items = this.items.filter(i => i !== item);
        },

        closeOthers(currentItem) {
            if (!this.exclusive) return;
            this.items.forEach(item => {
                if (item !== currentItem && item.isOpen()) {
                    item.close();
                }
            });
        }
    }));

    // Individual accordion item
    Alpine.data('accordionItem', () => ({
        _open: false,
        group: null,

        init() {
            // Try to find parent accordion group
            const groupEl = this.$el.closest('[x-data*="accordionGroup"]');
            if (groupEl && groupEl._x_dataStack) {
                this.group = groupEl._x_dataStack.find(d => d.registerItem);
                if (this.group) {
                    this.group.registerItem(this);
                }
            }

            // Check for hash-based opening
            const id = this.getAnchorId();
            if (id && window.location.hash === `#${id}`) {
                this._open = true;
            }
        },

        destroy() {
            if (this.group) {
                this.group.unregisterItem(this);
            }
        },

        isOpen() {
            return this._open;
        },

        toggle() {
            if (!this.isOpen()) {
                this.open();
            } else {
                this.close();
            }
        },

        open() {
            if (this.group) {
                this.group.closeOthers(this);
            }
            this._open = true;
            this.setAnchor();
        },

        openInitial() {
            if (this.group) {
                this.group.closeOthers(this);
            }
            this._open = true;
        },

        close() {
            this._open = false;
            this.clearAnchor();
        },

        getAnchorId() {
            const id = this.$root?.id || this.$el?.id || '';
            return id.trim();
        },

        setAnchor() {
            const id = this.getAnchorId();
            if (!id) return;
            const targetHash = `#${id}`;
            if (window.location.hash === targetHash) return;
            const url = `${window.location.pathname}${window.location.search}${targetHash}`;
            window.history.replaceState(null, '', url);
        },

        clearAnchor() {
            const id = this.getAnchorId();
            if (!id) return;
            if (window.location.hash !== `#${id}`) return;
            const url = `${window.location.pathname}${window.location.search}`;
            window.history.replaceState(null, '', url);
        }
    }));

    // Tabs component for Layout 3
    Alpine.data('accordionTabs', (config = {}) => ({
        activeTab: config.defaultTab || 0,
        totalTabs: 0,

        init() {
            // Count tabs
            this.totalTabs = this.$el.querySelectorAll('[role="tab"]').length;
        },

        setTab(index) {
            this.activeTab = index;
        },

        nextTab() {
            this.activeTab = (this.activeTab + 1) % this.totalTabs;
            this.focusActiveTab();
        },

        prevTab() {
            this.activeTab = (this.activeTab - 1 + this.totalTabs) % this.totalTabs;
            this.focusActiveTab();
        },

        focusActiveTab() {
            this.$nextTick(() => {
                const tabs = this.$el.querySelectorAll('[role="tab"]');
                if (tabs[this.activeTab]) {
                    tabs[this.activeTab].focus();
                }
            });
        }
    }));
});
